import { render, staticRenderFns } from "./productsModal.vue?vue&type=template&id=97cf2b0e&scoped=true"
import script from "./productsModal.vue?vue&type=script&lang=js"
export * from "./productsModal.vue?vue&type=script&lang=js"
import style0 from "./productsModal.vue?vue&type=style&index=0&id=97cf2b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cf2b0e",
  null
  
)

export default component.exports